import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { can } from "@/lib/roles";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Pitch from "@/pages/Pitch";
import Dashboard from "@/pages/Dashboard";
import Admissions from "@/pages/Admissions";
import ConceptPapers from "@/pages/ConceptPapers";
import Supervisions from "@/pages/Supervisions";
import SupervisionDetail from "@/pages/SupervisionDetail";
import Analytics from "@/pages/Analytics";
import Users from "@/pages/Users";
import Tenants from "@/pages/Tenants";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Notifications from "@/pages/Notifications";
import Oversight from "@/pages/Oversight";
import Profile from "@/pages/Profile";
import PublicUpload from "@/pages/PublicUpload";

function Guard({ k, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (k && !can(user, k)) return <Navigate to="/" replace />;
  return children;
}

const page = (key, el) => (
  <Layout>
    <Guard k={key}>{el}</Guard>
  </Layout>
);

function RootRoute() {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return page("dashboard", <Dashboard />);
  return <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pitch" element={<Pitch />} />
          <Route path="/apply/:token" element={<PublicUpload />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/institutions" element={page("institutions", <Tenants />)} />
            <Route path="/admissions" element={page("admissions", <Admissions />)} />
            <Route path="/concept-papers" element={page("concept", <ConceptPapers />)} />
            <Route path="/supervisions" element={page("supervision", <Supervisions />)} />
            <Route path="/supervisions/:id" element={page("supervision", <SupervisionDetail />)} />
            <Route path="/oversight" element={page("oversight", <Oversight />)} />
            <Route path="/analytics" element={page("analytics", <Analytics />)} />
            <Route path="/users" element={page("users", <Users />)} />
            <Route path="/audit" element={page("audit", <AuditLog />)} />
            <Route path="/settings" element={page("settings", <Settings />)} />
            <Route path="/notifications" element={page("notifications", <Notifications />)} />
            <Route path="/profile" element={page("profile", <Profile />)} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
